import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { Avatar, Box, CircularProgress, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { listAccessibleGroupsAPI } from "../../../../store/features/listGroup";
import { updateTicket } from "../../../../store/features/updateTicket";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import { toast } from "react-toastify";
import NoSearch from "../../../common/NoSearch";
import SearchInput from "../../../common/SearchInputField";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";

const inter = '"Inter", sans-serif';

function GroupPlaceholderIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 6H11.5C10.672 6 10 5.328 10 4.5V3.5C10 2.672 10.672 2 11.5 2H12.5C13.328 2 14 2.672 14 3.5V4.5C14 5.328 13.328 6 12.5 6Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 22H11.5C10.672 22 10 21.328 10 20.5V19.5C10 18.672 10.672 18 11.5 18H12.5C13.328 18 14 18.672 14 19.5V20.5C14 21.328 13.328 22 12.5 22Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12.5V11.5C18 10.672 18.672 10 19.5 10H20.5C21.328 10 22 10.672 22 11.5V12.5C22 13.328 21.328 14 20.5 14H19.5C18.672 14 18 13.328 18 12.5Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.5V11.5C2 10.672 2.672 10 3.5 10H4.5C5.328 10 6 10.672 6 11.5V12.5C6 13.328 5.328 14 4.5 14H3.5C2.672 14 2 13.328 2 12.5Z"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1505 4.91834C17.1525 4.92029 17.1525 4.92346 17.1505 4.92541C17.1486 4.92736 17.1454 4.92736 17.1434 4.92541C17.1415 4.92346 17.1415 4.92029 17.1434 4.91834C17.1454 4.91639 17.1486 4.91639 17.1505 4.91834"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0805 6.84266C19.0825 6.84461 19.0825 6.84777 19.0805 6.84973C19.0785 6.85168 19.0754 6.85168 19.0734 6.84973C19.0715 6.84777 19.0715 6.84461 19.0734 6.84266C19.0754 6.8407 19.0785 6.8407 19.0805 6.84266"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.85656 19.0746C6.85852 19.0765 6.85852 19.0797 6.85656 19.0817C6.85461 19.0836 6.85144 19.0836 6.84949 19.0817C6.84754 19.0797 6.84754 19.0765 6.84949 19.0746C6.85144 19.0726 6.85461 19.0726 6.85656 19.0746"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.92657 17.1503C4.92852 17.1522 4.92852 17.1554 4.92657 17.1573C4.92462 17.1593 4.92145 17.1593 4.9195 17.1573C4.91755 17.1554 4.91755 17.1522 4.9195 17.1503C4.92145 17.1483 4.92462 17.1483 4.92657 17.1503"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.92553 6.84949C4.92749 6.85144 4.92749 6.85461 4.92553 6.85656C4.92358 6.85852 4.92041 6.85852 4.91846 6.85656C4.91651 6.85461 4.91651 6.85144 4.91846 6.84949C4.92041 6.84754 4.92358 6.84754 4.92553 6.84949"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.84954 4.91932C6.8515 4.92127 6.8515 4.92443 6.84954 4.92639C6.84759 4.92834 6.84443 4.92834 6.84247 4.92639C6.84052 4.92443 6.84052 4.92127 6.84247 4.91932C6.84443 4.91736 6.84759 4.91736 6.84954 4.91932"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0815 17.1434C19.0834 17.1454 19.0834 17.1486 19.0815 17.1505C19.0795 17.1525 19.0764 17.1525 19.0744 17.1505C19.0725 17.1486 19.0725 17.1454 19.0744 17.1434C19.0764 17.1415 19.0795 17.1415 19.0815 17.1434"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1575 19.0736C17.1595 19.0756 17.1595 19.0787 17.1575 19.0807C17.1556 19.0826 17.1524 19.0826 17.1505 19.0807C17.1485 19.0787 17.1485 19.0756 17.1505 19.0736C17.1524 19.0717 17.1556 19.0717 17.1575 19.0736"
        stroke="#405261"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function memberCountLabel(group) {
  if (typeof group?.total_agents === "number") {
    return `${group.total_agents} member${group.total_agents !== 1 ? "s" : ""}`;
  }
  if (typeof group?.agents === "number") {
    return `${group.agents} member${group.agents !== 1 ? "s" : ""}`;
  }
  if (Array.isArray(group?.agents)) {
    return `${group.agents.length} member${group.agents.length !== 1 ? "s" : ""}`;
  }
  if (Array.isArray(group?.users)) {
    return `${group.users.length} member${group.users.length !== 1 ? "s" : ""}`;
  }
  return null;
}

const ChangeGroupPopup = ({ open, onClose, onSuccess, ticketId, currentGroups }) => {
  const dispatch = useDispatch();
  const [actualCurrentGroups, setActualCurrentGroups] = useState(currentGroups);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(currentGroups?.[0] || null);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const getGroupId = (group) => {
    if (!group) return null;
    return group._id || group.id || null;
  };

  useEffect(() => {
    if (open) {
      setSelectedGroup(currentGroups?.[0] || null);
      setActualCurrentGroups(currentGroups || []);
      setSearchTerm("");
    }
  }, [open, currentGroups]);

  useEffect(() => {
    if (!open) return;
    setLoadingData(true);
    dispatch(listAccessibleGroupsAPI())
      .then((res) => {
        if (res?.payload?.status === 200 && Array.isArray(res?.payload?.data)) {
          setGroupOptions(res.payload.data);
        } else {
          toast.error("Failed to fetch groups.");
        }
      })
      .catch(() => {
        toast.error("Error fetching groups.");
      })
      .finally(() => setLoadingData(false));
  }, [dispatch, open]);

  const updateTicketGroups = async (group) => {
    if (!group) return false;
    setLoading(true);
    try {
      const groupId = getGroupId(group);
      await dispatch(
        updateTicket({ ticketId, updateData: { groups: [groupId] } })
      ).unwrap();
      await dispatch(getTicketMessagesById({ ticketId, silent: true })).unwrap();
      toast.success("Group updated successfully!");
      setActualCurrentGroups([group]);
      if (typeof onSuccess === "function") {
        await onSuccess(group);
      }
      return true;
    } catch (err) {
      toast.error("Failed to update group.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleDone = async () => {
    const success = await updateTicketGroups(selectedGroup);
    if (success) onClose();
  };

  const isSelectionSameAsBefore = () => {
    const currentId = getGroupId(selectedGroup);
    const appliedId = getGroupId(actualCurrentGroups?.[0]);
    return currentId === appliedId;
  };

  const popupTitle =
    Array.isArray(currentGroups) && currentGroups.length > 0 ? "Change Group" : "Add Group";

  if (!open) return null;

  const selectedId = getGroupId(selectedGroup);
  const filteredGroups = groupOptions.filter(
    (group) =>
      group?.title && group.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const sortedGroups = [
    ...filteredGroups.filter((g) => getGroupId(g) === selectedId),
    ...filteredGroups.filter((g) => getGroupId(g) !== selectedId),
  ];

  return createPortal(
    <>
      <div
        className="overlay"
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 13000,
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
          opacity: 1,
        }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={popupTitle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 13001,
          width: 408,
          height: 384,
          maxWidth: "min(90vw, 408px)",
          maxHeight: "min(384px, calc(100vh - 32px))",
          padding: 24,
          borderRadius: 8,
          border: "1px solid #D5DCE1",
          background: "#FFF",
          boxShadow: "0px 15px 20px 0px rgba(6, 21, 34, 0.05)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            mb: 2,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: "#061522",
              fontFamily: inter,
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "18px",
            }}
          >
            {popupTitle}
          </Typography>
          <Box
            component="button"
            type="button"
            onClick={onClose}
            aria-label="Close"
            sx={{
              p: 0,
              border: 0,
              background: "transparent",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <Close />
          </Box>
        </Box>

        <Box sx={{ width: 360, maxWidth: "100%", flexShrink: 0, mb: 1.5 }}>
          <SearchInput
            noTitle
            iconPosition="left"
            iconVariant="people"
            value={searchTerm}
            placeholder="Search"
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "100%", height: 40 }}
            inputStyle={{
              height: 40,
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              fontFamily: inter,
              fontSize: 14,
            }}
          />
        </Box>

        <Box
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            width: 360,
            maxWidth: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            "&::-webkit-scrollbar": { width: 6 },
            "&::-webkit-scrollbar-thumb": {
              background: "#D5DCE1",
              borderRadius: "10px",
            },
          }}
        >
          {loadingData ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : sortedGroups.length === 0 ? (
            <NoSearch title="No groups found." description="Clear your search or try again." />
          ) : (
            sortedGroups.map((group) => {
              const groupId = getGroupId(group);
              if (!groupId) return null;
              const isSelected = selectedId === groupId;
              const members = memberCountLabel(group);

              return (
                <Box
                  key={groupId}
                  onClick={() => setSelectedGroup(group)}
                  role="option"
                  aria-selected={isSelected}
                  aria-label={`Group ${group.title}`}
                  sx={{
                    width: 360,
                    maxWidth: "100%",
                    height: 56,
                    flexShrink: 0,
                    borderRadius: "8px",
                    background: isSelected ? "#F9FAFA" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 1,
                    boxSizing: "border-box",
                    cursor: "pointer",
                    "&:hover": { background: "#F9FAFA" },
                  }}
                >
                  {group.group_image ? (
                    <Avatar
                      src={group.group_image}
                      alt={group.title}
                      sx={{ width: 40, height: 40, flexShrink: 0 }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        background: "#D6EDFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <GroupPlaceholderIcon />
                    </Box>
                  )}

                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        color: "#061522",
                        fontFamily: inter,
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: "18px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize",
                      }}
                    >
                      {group.title}
                    </Typography>
                    {members && (
                      <Typography
                        sx={{
                          color: "#556575",
                          fontFamily: inter,
                          fontSize: 12,
                          fontWeight: 400,
                          lineHeight: "18px",
                        }}
                      >
                        {members}
                      </Typography>
                    )}
                  </Box>

                  {isSelected && (
                    <CheckIcon sx={{ fontSize: 18, color: "#148DFD", flexShrink: 0 }} />
                  )}
                </Box>
              );
            })
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 2,
            flexShrink: 0,
          }}
        >
          <Box
            component="button"
            type="button"
            onClick={onClose}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              color: "#405261",
              fontFamily: inter,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              cursor: "pointer",
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            Cancel
          </Box>
          <Box
            component="button"
            type="button"
            onClick={handleDone}
            disabled={loading || !selectedGroup || isSelectionSameAsBefore()}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              border: 0,
              background: "#148DFD",
              color: "#FFF",
              fontFamily: inter,
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              cursor: "pointer",
              "&:hover": { background: "#0077CC" },
              "&:disabled": {
                background: "#93A1B0",
                cursor: "not-allowed",
              },
            }}
          >
            {loading ? "Updating..." : "Apply"}
          </Box>
        </Box>
      </div>
    </>,
    document.body
  );
};

export default ChangeGroupPopup;
